import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  deleteCountryHolidaysByIdQuery,
  getCountryHolidaysByIdQuery,
  getCountryHolidaysListQuery,
  createCountryHolidaysQuery,
  updateCountryHolidaysByIdQuery,
} from "./queries";

const CountryHolidaysContext = createContext({});

export const useCountryHolidaysContext = () =>
  useContext(CountryHolidaysContext);

export const CountryHolidaysProvider = ({ ...props }) => {
  const [countryHolidaysList, setCountryHolidaysList] = useState([]);
  const [countryHolidaysPerId, setCountryHolidaysPerId] = useState({});

  const getCountryHolidaysList = useCallback(async () => {
    try {
      if (countryHolidaysList.length === 0) {
        setCountryHolidaysList(await getCountryHolidaysListQuery());
      }
    } catch (e) {
      console.error("getCountryHolidaysList", e);
      throw e;
    }
  }, [countryHolidaysList]);

  const getCountryHolidaysById = useCallback(async (id) => {
    try {
      setCountryHolidaysPerId(await getCountryHolidaysByIdQuery(id));
    } catch (e) {
      console.error("getCountryHolidaysById", e);
      throw e;
    }
  }, []);

  const deleteCountryHolidaysById = useCallback(async (id) => {
    try {
      await deleteCountryHolidaysByIdQuery(id);
      setCountryHolidaysList((old) => old.filter((row) => row.id !== id));
    } catch (e) {
      console.error("deleteCountryHolidaysById", e);
      throw e;
    }
  }, []);

  const createCountryHolidays = useCallback(async (data) => {
    try {
      const country = await createCountryHolidaysQuery(data);
      setCountryHolidaysList((old) => [...old, country]);
    } catch (e) {
      console.error("createCountryHolidays", e);
      throw e;
    }
  }, []);

  const updateCountryHolidaysById = useCallback(async (id, data) => {
    try {
      const updatedCountry = await updateCountryHolidaysByIdQuery(id, data);
      setCountryHolidaysList((old) =>
        old.map((elm) => (elm.id === updatedCountry.id ? updatedCountry : elm))
      );
      setCountryHolidaysPerId(updatedCountry);
    } catch (e) {
      console.error("updateCountryHolidaysById", e);
      throw e;
    }
  }, []);
  const values = useMemo(
    () => ({
      getCountryHolidaysList,
      getCountryHolidaysById,
      deleteCountryHolidaysById,
      createCountryHolidays,
      updateCountryHolidaysById,
      countryHolidaysList,
      countryHolidaysPerId,
      setCountryHolidaysPerId,
    }),
    [
      getCountryHolidaysList,
      getCountryHolidaysById,
      deleteCountryHolidaysById,
      createCountryHolidays,
      updateCountryHolidaysById,
      countryHolidaysList,
      countryHolidaysPerId,
      setCountryHolidaysPerId,
    ]
  );
  return <CountryHolidaysContext.Provider value={values} {...props} />;
};
